/**
 * @generated SignedSource<<894c955033fd1ba17e54c79a83337f1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EventVisibility = "LISTED" | "UNLISTED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventItemEventCardPhoto_event$data = {
  readonly coverPhoto: {
    readonly desktopTransformUrl: string;
    readonly mobileTransformUrl: string;
  } | null | undefined;
  readonly name: string;
  readonly prettyUrl: string;
  readonly updatedAt: string | null | undefined;
  readonly visibility: EventVisibility;
  readonly " $fragmentType": "EventItemEventCardPhoto_event";
};
export type EventItemEventCardPhoto_event$key = {
  readonly " $data"?: EventItemEventCardPhoto_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventItemEventCardPhoto_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventItemEventCardPhoto_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "coverPhoto",
      "plural": false,
      "selections": [
        {
          "alias": "mobileTransformUrl",
          "args": [
            {
              "kind": "Literal",
              "name": "transform",
              "value": {
                "dpr": 3,
                "w": 576
              }
            }
          ],
          "kind": "ScalarField",
          "name": "transformUrl",
          "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":576})"
        },
        {
          "alias": "desktopTransformUrl",
          "args": [
            {
              "kind": "Literal",
              "name": "transform",
              "value": {
                "dpr": 3,
                "w": 200
              }
            }
          ],
          "kind": "ScalarField",
          "name": "transformUrl",
          "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":200})"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "9138d920bbd999c6c8c0fe03663014a2";

export default node;
